import { useState } from "react";
import { signOut } from "./signOut";

/**
 * "Sign out" button (top-bar account menu, Settings → Security, mobile Account). Disabled while
 * the request runs; a failed sign-out says so instead of doing nothing.
 */
export function SignOutButton({ className = "btn" }: { className?: string }): React.JSX.Element {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  return (
    <>
      <button
        type="button"
        className={className}
        disabled={busy}
        onClick={() => {
          setBusy(true);
          setError(null);
          signOut().catch((e: unknown) => {
            setBusy(false);
            setError(e instanceof Error ? e.message : "request failed");
          });
        }}
      >
        {busy ? "Signing out…" : "Sign out"}
      </button>
      {error && (
        <p className="login-error" role="alert">
          Sign-out failed: {error}
        </p>
      )}
    </>
  );
}
